<template>
    <div class="ForgotPassword">
        <div class="pass2" >
             <div class="proba1 container d-flex flex-column ">
                <img class="align-self-start" src="../assets/img/NAVIGATION.svg" alt="">
                  <div class="proba2 d-flex flex-column justify-content-center ">
                    <h1>Forgot your password?</h1>
                    <p>Enter the email address associated with this account. We will email you a link with instructions on how to reset your password.</p>
                    <form class="pt-4">
                    <div class="form-group">
                    <input type="email" class="form-control my-rounded text-center font-weight-bold"  id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your e-mail">
                    </div>
                    <button type="submit" class="btn btn-primary my-rounded mt-3 pl-5 pr-5">SEND</button>
                    </form>
                </div>
            </div>
         </div>
    </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  
}

</script>

<style scoped>

@import '../style.css';

.my-rounded{
    border-radius: 50px;
}

.btn-primary {
    color: #fff;
    background-color: #29E4B7;
    border-color: #29E4B7;
}

.form-control{
    width: 50%;
    color: #29E4B7!important;   
}

.form-control:focus{
    color: #29E4B7!important;
}
::placeholder{
    color: #29E4B7!important;
}

.pl-5{
    padding-left: 5rem!important;
}
.pr-5{
    padding-right: 5rem!important;
}

/* drugi korak */
.pass2{
    width: 100%;
    height: 100vh;
    background-color:#202646;
    color: white;
}

.proba2{
    height: 80vh;
}



</style>